import React from 'react'
import SliderTestimonial from '../../component/slidercomponent/SliderTestimonial'

const HomeTestimonials = () => {
    return (
        <>

            <section className="testimonial-one" style={{ marginTop: "-50px" }}>
                <div className="testimonial-one_pattern" style={{ backgroundImage: 'url(assets/images/background/pattern-6.png)' }} />
                <div className="auto-container">
                    <div className="sec-title centered" style={{ marginTop: "-70px" }}>
                        <h2 className="sec-title_heading">What Say Our Patients!</h2>
                    </div>

                    <SliderTestimonial />

                    {/* <div className="testimonial-carousel owl-carousel owl-theme owl-loaded owl-drag">

                        <div className="owl-stage-outer">
                            <div className="owl-stage" style={{ transform: 'translate3d(-1200px, 0px, 0px)', transition: 'all', width: 4800 }}>
                                <div className="owl-item cloned" style={{ width: 400 }}>
                                    <div className="testimonial-block_one">
                                        <div className="testimonial-block_one-inner">
                                            <div className="testimonial-block_one-author">
                                                <img src="assets/images/resource/author-1.jpg" alt />
                                                <span className="testimonial-block_one-quote fa-solid fa-quote-left fa-fw" />
                                            </div>
                                            <div className="testimonial-block_one-content">
                                                <div className="testimonial-block_one-rating">
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                </div>
                                                <div className="testimonial-block_one-designation">Market Manager</div>
                                                <h3 className="testimonial-block_one-heading">Jame Sickres</h3>
                                            </div>
                                            <div className="testimonial-block_one-text">Lorem ipsum dolor sit amet, ut consectetur adipisicing elit, sed do eiusmod tempor incididunt labore et dolore magna aliqua.</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="owl-item active" style={{ width: 400 }}>
                                    <div className="testimonial-block_one">
                                        <div className="testimonial-block_one-inner">
                                            <div className="testimonial-block_one-author">
                                                <img src="assets/images/resource/author-1.jpg" alt />
                                                <span className="testimonial-block_one-quote fa-solid fa-quote-left fa-fw" />
                                            </div>
                                            <div className="testimonial-block_one-content">
                                                <div className="testimonial-block_one-rating">
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                </div>
                                                <div className="testimonial-block_one-designation">Market Manager</div>
                                                <h3 className="testimonial-block_one-heading">Jame Sickres</h3>
                                            </div>
                                            <div className="testimonial-block_one-text">Lorem ipsum dolor sit amet, ut consectetur adipisicing elit, sed do eiusmod tempor incididunt labore et dolore magna aliqua.</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="owl-item active" style={{ width: 400 }}>
                                    <div className="testimonial-block_one">
                                        <div className="testimonial-block_one-inner">
                                            <div className="testimonial-block_one-author">
                                                <img src="assets/images/resource/author-2.jpg" alt />
                                                <span className="testimonial-block_one-quote fa-solid fa-quote-left fa-fw" />
                                            </div>
                                            <div className="testimonial-block_one-content">
                                                <div className="testimonial-block_one-rating">
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                </div>
                                                <div className="testimonial-block_one-designation">Jackson Marker</div>
                                                <h3 className="testimonial-block_one-heading">Sale Manager</h3>
                                            </div>
                                            <div className="testimonial-block_one-text">Lorem ipsum dolor sit amet, ut consectetur adipisicing elit, sed do eiusmod tempor incididunt labore et dolore magna aliqua.</div>
                                        </div>
                                    </div>
                                </div>


                                <div className="owl-item" style={{ width: 400 }}>
                                    <div className="testimonial-block_one">
                                        <div className="testimonial-block_one-inner">
                                            <div className="testimonial-block_one-author">
                                                <img src="assets/images/resource/author-1.jpg" alt />
                                                <span className="testimonial-block_one-quote fa-solid fa-quote-left fa-fw" />
                                            </div>
                                            <div className="testimonial-block_one-content">
                                                <div className="testimonial-block_one-rating">
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                </div>
                                                <div className="testimonial-block_one-designation">Market Manager</div>
                                                <h3 className="testimonial-block_one-heading">Jame Sickres</h3>
                                            </div>
                                            <div className="testimonial-block_one-text">Lorem ipsum dolor sit amet, ut consectetur adipisicing elit, sed do eiusmod tempor incididunt labore et dolore magna aliqua.</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 400 }}>
                                    <div className="testimonial-block_one">
                                        <div className="testimonial-block_one-inner">
                                            <div className="testimonial-block_one-author">
                                                <img src="assets/images/resource/author-2.jpg" alt />
                                                <span className="testimonial-block_one-quote fa-solid fa-quote-left fa-fw" />
                                            </div>
                                            <div className="testimonial-block_one-content">
                                                <div className="testimonial-block_one-rating">
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                </div>
                                                <div className="testimonial-block_one-designation">Jackson Marker</div>
                                                <h3 className="testimonial-block_one-heading">Sale Manager</h3>
                                            </div>
                                            <div className="testimonial-block_one-text">Lorem ipsum dolor sit amet, ut consectetur adipisicing elit, sed do eiusmod tempor incididunt labore et dolore magna aliqua.</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="owl-item cloned" style={{ width: 400 }}>
                                    <div className="testimonial-block_one">
                                        <div className="testimonial-block_one-inner">
                                            <div className="testimonial-block_one-author">
                                                <img src="assets/images/resource/author-1.jpg" alt />
                                                <span className="testimonial-block_one-quote fa-solid fa-quote-left fa-fw" />
                                            </div>
                                            <div className="testimonial-block_one-content">
                                                <div className="testimonial-block_one-rating">
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                    <span className="fa fa-star" />
                                                </div>
                                                <div className="testimonial-block_one-designation">Market Manager</div>
                                                <h3 className="testimonial-block_one-heading">Jame Sickres</h3>
                                            </div>
                                            <div className="testimonial-block_one-text">Lorem ipsum dolor sit amet, ut consectetur adipisicing elit, sed do eiusmod tempor incididunt labore et dolore magna aliqua.</div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>

                    </div> */}
                </div>
            </section>

        </>
    )
}

export default HomeTestimonials